import React from "react";
import Styles from "./index.module.scss";
import { Col, Row, Spin } from "antd";
import ListItem from "./Components/ListItem";
import { evaluationCourseList } from "../Service";
import useRequest from "../../../utils/useRequest";

const Index = () => {
    const [data, { loading }] = useRequest(evaluationCourseList, {}, []);
    if (!data) {
        return null;
    }
    return (
        <div className={Styles.root}>
            <Spin spinning={loading}>
                <Row type="flex" gutter={30}>
                    {data?.list?.map(item => (
                        <Col span={8} key={item.evaluationId}>
                            <ListItem item={item} />
                        </Col>
                    ))}
                </Row>
            </Spin>
        </div>
    );
};

export default Index;
